import { mapListToRecords, normalizeList, websocketsHandlerFactory } from '@sophocles/entities/entityUtils';
import { RelaySchedule, relayScheduleSchema } from '@sophocles/entities/RelaySchedule/relayScheduleRecord';
import apiClient from '@sophocles/http-common';
import { checkHttpStatus, genericErrorAction } from '@sophocles/utils';
import { normalize } from 'normalizr';

/* Receive Actions */
export const RECEIVE_RELAY_SCHEDULES = 'RECEIVE_RELAY_SCHEDULES';
export function receiveRelaySchedules(json) {
  return {
    type: RECEIVE_RELAY_SCHEDULES,
    relaySchedules: mapListToRecords(json, RelaySchedule),
  };
}

/* Request Actions */
export const REQUEST_SITE_RELAY_SCHEDULES = 'REQUEST_SITE_RELAY_SCHEDULES';
function requestSiteRelaySchedules(site_id) {
  return {
    type: REQUEST_SITE_RELAY_SCHEDULES,
    site_id,
  };
}

/* Fetch Actions */
export function fetchRelaySchedulesForSite(site_id) {
  return dispatch => {
    dispatch(requestSiteRelaySchedules(site_id));
    return apiClient
      .get(`/sites/${site_id}/relayschedules/`)
      .then(response => normalizeList(response.data.results, 'relaySchedules', relayScheduleSchema))
      .then(json => dispatch(receiveRelaySchedules(json.entities.relaySchedules)));
  };
}

/* Edit Actions */
export const EDIT_RELAY_SCHEDULE = 'EDIT_RELAY_SCHEDULE';
export function editRelaySchedule(relaySchedule_id) {
  return {
    type: EDIT_RELAY_SCHEDULE,
    relaySchedule: relaySchedule_id,
  };
}

export function patchRelaySchedule(id, values) {
  return dispatch => {
    dispatch(editRelaySchedule(id));
    return apiClient
      .patch(`/relayschedules/${id}/`, values)
      .then(checkHttpStatus)
      .then(response => normalize(response.data, relayScheduleSchema))
      .then(json => dispatch(receiveRelaySchedules(json.entities.relaySchedules)))
      .catch(error => dispatch(genericErrorAction(error, 'PATCH_RELAY_SCHEDULE')));
  };
}
export const MATCH_RELAY_SCHEDULE_OFFSETS = 'MATCH_RELAY_SCHEDULE_OFFSETS';
export function matchRelayScheduleOffsets(relays, sunsetOffset, sunriseOffset) {
  return {
    type: MATCH_RELAY_SCHEDULE_OFFSETS,
    relays,
    sunsetOffset,
    sunriseOffset,
  };
}

const receiver = (dispatch, json) => dispatch(receiveRelaySchedules(json.entities.relaySchedules));

export const handleRelayScheduleSocketActions = websocketsHandlerFactory(
  receiver,
  () => console.log('no delete'),
  relayScheduleSchema,
);
